import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {CreateModifierGroupRequest, DisplayedProduct, ModifierGroupInfo, UpdateModifierGroupRequest} from "app/models/menu.model";
import {firstValueFrom, Observable} from "rxjs";
import {environment} from "environments/environment";
import {IBaseResponse} from "app/models/baseResponse.model";

@Injectable({
  providedIn: 'root'
})
export class ModifierGroupApiService {
  private requestPath = `${environment.posBaseUrl}/api/front/modifiergroup`;
  private headers: HttpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
  });

  constructor(
    private http: HttpClient,
  ) {}

  async getModifierGroupsAsync(organizationId: string) : Promise<ModifierGroupInfo[]> {
    try{
      const response = await firstValueFrom(
        this.http.get<IBaseResponse<ModifierGroupInfo[]>>(
          this.requestPath + '/' + organizationId + '/list',
        )
      )
      return response.data;
    }
    catch(exception){
      console.log('exception', exception);
      return exception;
    }
  }

  async createModifierGroupAsync(requestBody: CreateModifierGroupRequest) : Promise<ModifierGroupInfo> {
    try{
      const response = await firstValueFrom(
        this.http.post<IBaseResponse<ModifierGroupInfo>>(
          this.requestPath,
          requestBody,
          {
            headers: this.headers,
          }
        )
      )
      return response.data;
    }
    catch(exception){
      console.log('exception', exception);
      return exception;
    }
  }

  async updateModifierGroupAsync(modifierGroupId: string, requestBody: UpdateModifierGroupRequest) : Promise<ModifierGroupInfo> {
    try{
      const response = await firstValueFrom(
        this.http.put<IBaseResponse<ModifierGroupInfo>>(
          this.requestPath + '/' + modifierGroupId,
          requestBody,
          {
            headers: this.headers,
          }
        )
      )
      return response.data;
    }
    catch(exception){
      console.log('exception', exception);
      return exception;
    }
  }

  async deleteModifierGroupAsync(modifierGroupId: string) : Promise<any> {
    try{
      const response = await firstValueFrom(
        this.http.delete<IBaseResponse<any>>(
          this.requestPath + `/${modifierGroupId}`,
        )
      )
      return response.data;
    }
    catch(exception){
      console.log('exception', exception);
      return exception;
    }
  }

  async getModifierListAsync(organizationId: string) : Promise<DisplayedProduct[]> {
    try{
      const response = await firstValueFrom(
        this.http.get<IBaseResponse<DisplayedProduct[]>>(
          this.requestPath + `/${organizationId}/modifiers`
        )
      )
      return response.data;
    }
    catch(exception){
      console.log('exception', exception);
      return exception;
    }
  }

  async applyModifierGroupsAsync(organizationId: string, modifierGroups: string[]) : Promise<any> {
    try{
      const response = await firstValueFrom(
        this.http.post<IBaseResponse<any>>(
          this.requestPath + `/${organizationId}/apply`,
          modifierGroups,
          {
            headers: this.headers,
          }
        )
      )
      return response.data;
    }
    catch(exception){
      console.log('exception', exception);
      return exception;
    }
  }
}
